import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 py-10 relative z-10">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 flex flex-col items-center gap-7 text-center lg:flex-row lg:justify-between lg:text-left">
      <div>
        <p className="font-display font-bold text-sm">
          <span className="text-gold">Local</span>Business<span className="text-gold">Jingle</span>
          <span className="text-slate-500">.com</span>
        </p>
        <p className="mt-2 font-mono text-[11px] text-slate-600 tracking-wider">
          © 2026 — Turn up your business.
        </p>
      </div>

      <div data-testid="footer-contact-section" className="rounded-2xl border border-gold/20 bg-gold/5 px-5 py-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold mb-1.5">
          Contact us for support
        </p>
        <a
          data-testid="footer-contact-email"
          href="mailto:Pepper@localbusinessjingle.com"
          className="inline-flex items-center gap-2 text-sm font-bold text-white hover:text-gold transition-colors"
        >
          <Mail className="h-4 w-4 text-gold" />
          Pepper@localbusinessjingle.com
        </a>
        <p className="mt-1.5 text-xs text-slate-500">
          Questions about an order, revision, download, or delivery.
        </p>
      </div>

      <nav aria-label="Legal" className="flex items-center gap-6 text-xs text-slate-500">
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-gold transition-colors">Privacy Policy</Link>
        <Link to="/terms" data-testid="footer-terms-link" className="hover:text-gold transition-colors">Terms of Service</Link>
      </nav>
    </div>
  </footer>
);
